import { useSaturated } from '@/store';
import useTicketsContext from '@/contexts/tickets/useTicketsContext';
import SaturatedTimer from '@/templates/plus/sections/saturated/SaturatedTimer';

export default function Saturated({ disableTries = false, view }) {
  const { isEnabled, start: startDate, tries } = useSaturated();
  const { isCallBackAction } = useTicketsContext();

  return (
    <>
      {isEnabled && startDate && (
        <>
          {!isCallBackAction && (
            <SaturatedTimer
              tries={tries}
              disableTries={disableTries}
              view={view}
            />
          )}
        </>
      )}
    </>
  );
}
